import React from 'react';
import Icon from '../../../components/AppIcon';

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="w-full bg-white border-b border-[#E5E7EB] py-4 md:py-6">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {steps?.map((step, index) => {
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;
            const isLast = index === steps?.length - 1;

            return (
              <React.Fragment key={step?.id}>
                <div className="flex flex-col items-center gap-2 flex-1 relative">
                  <div
                    className={`w-8 h-8 md:w-10 md:h-10 rounded-full border-2 flex items-center justify-center transition-all duration-250 ${
                      isCompleted
                        ? 'border-[#10B981] bg-[#10B981]'
                        : isActive
                        ? 'border-[#0025cc] bg-[#0025cc]'
                        : 'border-[#E5E7EB] bg-white'
                    }`}
                  >
                    {isCompleted ? (
                      <Icon name="Check" size={16} color="#FFFFFF" />
                    ) : (
                      <span
                        className={`text-sm md:text-base font-medium ${
                          isActive ? 'text-white' : 'text-[#6B7280]'
                        }`}
                      >
                        {index + 1}
                      </span>
                    )}
                  </div>
                  <span
                    className={`text-xs md:text-sm font-medium text-center whitespace-nowrap ${
                      isActive ? 'text-[#111827]' : 'text-[#6B7280]'
                    } ${isActive ? 'block' : 'hidden md:block'}`}
                  >
                    {step?.label}
                  </span>
                </div>
                {!isLast && (
                  <div
                    className={`h-0.5 flex-1 mx-2 transition-all duration-250 ${
                      isCompleted ? 'bg-[#10B981]' : 'bg-[#E5E7EB]'
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;